import { render } from "./GaleriaImagenes.vue?vue&type=template&id=61074c89"
import script from "./GaleriaImagenes.vue?vue&type=script&lang=js"
export * from "./GaleriaImagenes.vue?vue&type=script&lang=js"

import "./GaleriaImagenes.vue?vue&type=style&index=0&id=61074c89&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__